import { Iconsvg } from "@wk/components-react16";

const Tags = ({ data }: any) => {
    const { tags } = data;
    const groupedTags: { [key: string]: any[] } = {};
    tags?.forEach((tag: any) => {
        if (!groupedTags[tag.taxonomyType]) {
            groupedTags[tag.taxonomyType] = [];
        }
        groupedTags[tag.taxonomyType].push(tag);
    });

    return (
        <>
            {tags?.length > 0 ? <Iconsvg name="tags" color="#EFAB40" size={14}></Iconsvg> : null}{" "}
            {Object.entries(groupedTags).map(([taxonomyType, tagsOfType]: any) => (
                <span key={taxonomyType} className='mr-5 badge text-bg-light align-middle'>
                    <span className='align-middle wk-primary-blue type'>{taxonomyType}</span>
                    {" "}<Iconsvg name="chevron-right" color="#EFAB40" size={10}></Iconsvg>
                    {tagsOfType.map((tag: any, i: number) => (
                        <span key={i} className='align-middle wk-size-1 wk-weight-400'>
                            {tag.name}  {i < tagsOfType.length - 1 ? ", " : ""}
                        </span>
                    ))}
                </span>
            ))}
        </>
    );
};

export default Tags;